/**
 * @param {Record<string, unknown>} template
 * @param {Record<string, unknown>} stream
 */
export function actionStep(template, stream) {
  return {
    kind: 'action',
    durationMs: template.durationMs,
    actionName: template.actionName,
    arguments: template.arguments,
    result: template.result,
    status: template.status,
    defaultExpanded: false,
    stream,
  }
}

/**
 * @param {string} content
 */
export function narrationStep(content) {
  return {
    kind: 'narration',
    content,
  }
}
